import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25LoadingInlineModule } from "../../modules/s25-loading/s25.loading.inline.module";
import { s25Resource } from "../../util/s25.resource";
import { NewsArticleService } from "../../services/news.article.service";
import { NewsArticleListComponent } from "../organization-news/news.article.list.component";

@TypeManagerDecorator("s25-ng-se-my-news")
@Component({
    selector: "s25-ng-se-my-news",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25LoadingInlineModule, NewsArticleListComponent],
    template: `
        @if (articlesResource.resource.isLoading()) {
            <s25-ng-loading-inline-static />
        } @else {
            <s25-ng-news-article-list [articles]="articles()" />
        }
    `,
})
export class SeMyNewsComponent {
    limit = input(10);

    protected articlesResource = s25Resource({
        loader: () => NewsArticleService.getMyNews(this.limit()),
    });

    articles = computed(() => this.articlesResource.value() ?? []);
}
